import type {
  Command,
  ISessionOptions,
  Language,
  SessionOutput,
  SessionStatus,
} from '@datacamp/multiplexer-client';
import mux from '@datacamp/multiplexer-client';
import type { Observable } from 'rxjs/Observable';
import type { Subscription } from 'rxjs/Subscription';

import type { DualCodeExecutionBackend } from './dualCodeExecutionBackend';
import type { PyodideBackend } from './pyodideBackend';

let codeExecutionBackend: CodeExecutionBackend | undefined;

export type Subscriber<T> = (state: T) => void;
export type SubscriptionDeleter = () => void;

export type CodeExecutionBackend = {
  client: {
    off: (event: string) => void;
    on: (event: string, callback: (data: any) => void) => void;
  };
  input: (command: Command) => Promise<void> | void;
  options: {
    language: Language;
  };
  output$: Observable<SessionOutput | SessionOutput[]>;
  start: (
    options: ISessionOptions,
    initCommand: Command & { externalId?: number },
  ) => Promise<void> | void;
  stop: () => Promise<unknown>;
  stopPolling: () => void;
  subscribe: (subscriber: Subscriber<SessionStatus>) => SubscriptionDeleter;
  subscribeToOutputs: (
    predicate: (outputs: SessionOutput | SessionOutput[]) => boolean,
    listener: (outputs: SessionOutput | SessionOutput[]) => void,
  ) => Subscription;
};

export const getCodeExecutionBackend = (): CodeExecutionBackend | undefined => {
  return codeExecutionBackend;
};

export const setCodeExecutionBackend = (
  newCodeExecutionBackend: CodeExecutionBackend,
): void => {
  codeExecutionBackend = newCodeExecutionBackend;
};

export const isCodeExecutionBackendNotMux = (
  backend?: CodeExecutionBackend,
): backend is DualCodeExecutionBackend | PyodideBackend => {
  return !(backend instanceof mux.AsyncSession);
};

export const isDualCodeExecutionBackend = (
  backend?: CodeExecutionBackend,
): backend is DualCodeExecutionBackend => {
  return (
    !!backend &&
    !(backend instanceof mux.AsyncSession) &&
    (backend as DualCodeExecutionBackend).options.backendToShow !== undefined
  );
};
